import React from "react";
import styles from "./footer.module.css";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

const Footer = ({handleShow}) => {
  return (
    <React.Fragment>
      <div className={styles.footer_section}>
        <Container>
          <div className={styles.logo}>
            <h6>BuildShell.in</h6>
          </div>

          {/*  */}

          <div className={styles.bottom_footer}>
            <p>
              <Link onClick={handleShow} className="text-nowrap" to={"#"}>Contact Us</Link>
            </p>
            <p>
              <Link to={"/privacy"}>Privacy Policy</Link>
            </p>
            <p>
              <Link className="text-nowrap" to={"/tnc"}>Terms & Conditions</Link>
            </p>
          </div>
          <small className="text-white mb-0 pb-0 fw-normal">© BuildShell.in</small>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Footer;
